import { motion } from "framer-motion";
import { TrendingDown, TrendingUp, IndianRupee, Target, Truck, MapPin } from "lucide-react";

const CARDS = [
  { icon: IndianRupee, label: "Shipping Cost", value: "-18%", trend: "down", tint: "#10B981", bars: [70, 62, 66, 54, 48, 44, 38] },
  { icon: Target, label: "Delivery Success", value: "94.6%", trend: "up", tint: "#12C8F5", bars: [60, 66, 72, 70, 78, 84, 90] },
  { icon: TrendingDown, label: "RTO Rate", value: "3.1%", trend: "down", tint: "#FF9933", bars: [80, 74, 70, 60, 52, 46, 40] },
  { icon: IndianRupee, label: "COD Visibility", value: "100%", trend: "up", tint: "#10B981", bars: [50, 58, 66, 72, 80, 88, 96] },
  { icon: Truck, label: "Courier Performance", value: "Live", trend: "up", tint: "#12C8F5", bars: [44, 58, 52, 70, 64, 80, 88] },
  { icon: MapPin, label: "Pincode Performance", value: "Zone A–E", trend: "up", tint: "#FF9933", bars: [56, 48, 64, 58, 72, 68, 84] },
];

export default function AnalyticsSection() {
  return (
    <section className="relative overflow-hidden bg-[#071B3A] py-20 sm:py-24" data-testid="analytics-section">
      <div className="pointer-events-none absolute inset-0 hero-grid opacity-25" />
      <div className="relative mx-auto max-w-7xl px-5">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }}>
          <span className="text-xs font-bold uppercase tracking-[0.22em] text-shipany-cyan">Analytics</span>
          <h2 className="font-display mt-3 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">Shipping Intelligence That Helps You Grow</h2>
          <p className="mt-3 max-w-xl text-sm text-slate-400 sm:text-base">Cost, success, RTO, COD and courier performance — measured per lane, per pincode, per partner.</p>
        </motion.div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((c, i) => (
            <motion.div key={c.label} initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.07, duration: 0.5 }} whileHover={{ y: -5 }}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur transition-colors hover:border-white/25"
              data-testid={`analytics-card-${c.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-400">
                  <c.icon className="h-4 w-4" style={{ color: c.tint }} /> {c.label}
                </span>
                <span className={`mono flex items-center gap-1 text-sm font-extrabold`} style={{ color: c.tint }}>
                  {c.trend === "up" ? <TrendingUp className="h-3.5 w-3.5" /> : <TrendingDown className="h-3.5 w-3.5" />} {c.value}
                </span>
              </div>
              <div className="mt-4 flex h-16 items-end gap-1">
                {c.bars.map((b, k) => (
                  <motion.span key={k} initial={{ height: 0 }} whileInView={{ height: `${b}%` }} viewport={{ once: true }}
                    transition={{ delay: 0.2 + k * 0.05, duration: 0.5 }}
                    className="flex-1 rounded-t" style={{ background: `linear-gradient(180deg, ${c.tint}, ${c.tint}55)` }} />
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
